module.exports = __webpack_public_path__ + "static/media/PlutoRegular.fb759663.ttf";